import { createSlice } from "@reduxjs/toolkit";
import axios from "../../services/authService";
import { API_ENDPOINTS } from '../../config/apiConfig';

export const deleteEventSlice = createSlice({
    name: "deleteEvent",
    initialState: {
        loading: false,
        response: {},
        error: null
    },
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.response = {};
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setResponse: (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const {
    reset,
    setLoading,
    setResponse,
    setError
} = deleteEventSlice.actions;

/**
 * Delete an event from the database (backend cascades to scenarios/attributes)
 * @param {number} eventDbId - The database ID of the event to delete
 */
export const deleteEventAsync = (eventDbId) => async (dispatch) => {
    dispatch(reset());
    dispatch(setLoading(true));

    try {
        // Build the URL with query parameter
        const url = `${API_ENDPOINTS.DELETE_EVENT_OR_FLOW}?test_event_id=${eventDbId}`;

        // Make the DELETE request
        const response = await axios.delete(url);

        dispatch(setResponse({
            message: "Event deleted successfully",
            data: response.data
        }));

        return {
            success: true,
            data: response.data
        };

    } catch (err) {
        const errorMessage = err.response?.data?.message || err.message || "Failed to delete event";
        console.error("Error deleting event:", errorMessage);
        dispatch(setError(errorMessage));
        return {
            success: false,
            error: errorMessage
        };
    }
};

// Selectors
export const selectDeleteEventLoading = (state) => state.deleteEvent.loading;
export const selectDeleteEventResponse = (state) => state.deleteEvent.response;
export const selectDeleteEventError = (state) => state.deleteEvent.error;

export default deleteEventSlice.reducer;
